import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'
import { metodoPrograma } from '../../../components/api'

const Quarto = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const exclui = useCallback((dadosQuarto) => {
    metodoPrograma('exclui', { idQuarto: dadosQuarto[0] }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  const voltar = () => {
    setDados(null)
    setTela('lista')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton
              onClick={() => {
                setTela('lista')
                setDados(undefined)
              }}
            >
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
  }, [tela])

  return (
    <Programa codigo="CtrlQuarto" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              codigo="CtrlQuarto"
              action="lista"
              rows={10}
              habSearch
              head={['Número', 'Descrição', 'Inclusão', 'Exclusão']}
              line={(item) => [item[1], item[2], item[3], item[4]]}
              collumnsDate={[2]}
              collumnsDateHour={[3]}
              collumnsCurrency={[]}
              parametros={{ teste: true }}
              onRowSelect={handleClick}
              onDelete={{ index: 3, action: exclui }}
              refresh={refresh}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar, setTela }} />
      )}
    </Programa>
  )
}

export default Quarto
